import { defineStore } from 'pinia'
import Actions from './actions'
import { useState } from './state'

export { type AppState } from './state'

export const useAppStore = defineStore('app', {
  state: useState,
  actions: Actions
})

export type AppStoreContext = ReturnType<typeof useAppStore>